/**
 * author： blake.li
 * createDate: 2020-01-16
 * description: 跳转
 */
import {isQunarApp, isQunarWxApp, isFlightWxApp} from "./env";

/**
 * 通用跳转方法（支持机票微信小程序、公共微信小程序、端内scheme、端内hy、普通页面跳转。）
 * TODO：支持直接本页刷新、跳转页面、是否清栈等。这个待梳理
 * 参数描述: config 为object 类型
 * config = {
 *     url: 跳转链接（可以是url链接、小程序地址、scheme）必填
 *     flightWxUrl: 机票小程序内原生页面地址，机票小程序内如果有原生页面跳转原生否则跳转统一的webView页
 *     onViewBack：跳转成功后的回调函数，目前仅hy方式、scheme跳转支持，其他不支持
 *     name: hy方式传入openWebView
 *     data: hy方式传入openWebView
 *     miniUser: 设置了之后，可在端内直接打开微信小程序某个页面
 *
 *     headerType: hy方式传入openWebView
 *     headerSkin: white blue
 *     headerTitle: 头部标题
 *     headerColor: 标题颜色
 *     headerConfig: 导航栏配置，格式如navigation
 * }
 */

const appIdList = {
    isFlightWxApp: 'wx434593dc36c368fa', // 机票小程序
    isQunarWxApp: 'wx799d4d93a341b368' //客户端小程序
};

function jump(config = {}) {
    let url = config.url;
    let isRedirect = config.isRedirect;
    let flightWxUrl = config.flightWxUrl;
    if (!url) {
        return;
    }
    if ((isQunarWxApp() || isFlightWxApp())) {
        const isSameWxApp = isQunarWxApp() && config.appId === appIdList.isQunarWxApp
            || isFlightWxApp() && config.appId === appIdList.isFlightWxApp;
        if (config.appId && !isSameWxApp) {
            jumpOtherWxApp(config)
        } else {
            // 小程序内部跳转
            jumpWxAppPage(url, flightWxUrl, isRedirect);
        }
    } else {
        let jumpUrl = completeURL(url);
        if (isQunarApp()) {
            // 去哪大客户端
            let isScheme = jumpUrl.toLowerCase().substr(0, 5) === 'qunar';
            if (isScheme) {
                // native scheme
                jumpNativeScheme(config, jumpUrl);
            } else if(config.miniUser && config.miniUser !== 'undefined') {
                // launchMiniProgram
                hysdk.launchMiniProgram({
                    userName: config.miniUser,
                    path: url,
                    miniprogramType: 0,
                    success: function(data) {
                        console.log(data);
                    },
                    fail: function(err) {
                        console.error(err);
                    }
                });
            } else {
                // hy方式url跳转
                config.url = jumpUrl
                jumpHyPage(config);
            }
        } else {
            jumpBrowserPage(jumpUrl);
        }
    }
}
// 截止2020 4月版，adr不支持在弹窗里以hysdk.openWebView再打开一个webview，因此和ios都统一用schema形式跳转
// 仅用于特殊情况，其他使用jump跳转~
function openSchema (jumpUrl, appHead) {
    let url = '';

    // 校验打开地址是否正常
    if (/(http|https):\/\//i.test(jumpUrl)) {
        // 缩写名称不能转码
        jumpUrl = `hy?url=${encodeURIComponent(jumpUrl)}`;
        if (appHead) {
            // type不转码,当缩写的时候不能拼写type。都必须要加上头部
            jumpUrl = `${jumpUrl}&type=${appHead}`;
        }
    }

    // 配置中是否有scheme，有的话使用配置
    if (hysdk.sniff.scheme) {
        url = `${hysdk.sniff.scheme}://${jumpUrl}`;
    } else {
        let scheme = hysdk.sniff.ios ? 'qunariphone' : 'qunaraphone';
        url = `${scheme}://${jumpUrl}`;
    }

    location.href = url;
}

// 修复scheme、无协议， https://wiki.corp.qunar.com/confluence/display/~zhaoshuo.zhao/Scheme
function completeURL(url){
    let resultURL = url;
    if (/^:\/\//.test(url) && isQunarApp()) { // 是scheme ==> ://flight
        resultURL = hysdk.sniff.scheme + url;
    }else if (/^\/\//.test(url)) { // 是scheme ==> //m.flight.qunar.com
        resultURL = location.protocol + url;
    }
    return resultURL;
}

function jumpWxAppPage(url, flightWxUrl, isRedirect) {
    if (isFlightWxApp() && flightWxUrl) {
        // 如果给了机票小程序url，且运行在机票小程序，强制用flightWxUrl跳转
        url = flightWxUrl
    }

    let baseUrl = '/flight/pages/h5/h5?url=';
    let jumpUrl = /^http/.test(url) ? (baseUrl + encodeURIComponent(url)) : url;

    if (isRedirect) {
        wx.miniProgram.redirectTo({
            url: jumpUrl
        });
    } else {
        wx.miniProgram.navigateTo({
            url: jumpUrl
        });
    }
}

function jumpNativeScheme(config, scheme) {
    let schemeJumpConfig = {
        scheme: scheme,
        success: () => {
            config.onViewback && config.onViewback();
        }
    };

    hysdk.schemeForResult(schemeJumpConfig);
}

function jumpHyPage(config) {
    let {
        url, name, data = {}, headerType = 'navibar-none', onViewBack = () => {
        }
    } = config;



    let navigation = getHeaderConfig(config);
    hysdk.openWebView({
        url,
        name,
        data,
        type: headerType,
        navigation,
        onViewBack
    });
}

function jumpBrowserPage(url) {
    window.location.href = url;
}

function getHeaderConfig (config) {
    let { headerConfig = {}, headerSkin, headerTitle, headerColor } = config || {};

    // 自定navigation
    if (headerConfig && Object.keys(headerConfig).length !== 0) {
        return headerConfig;
    }

    // 白色主题nav header
    if (headerSkin === 'white') {
        headerConfig = {
            color: {
                backgroundColor: '#FFF',
                textColor: {
                    normal: '#212121'
                }
            },
            left: {
                style: 'icon',
                icon: '\uf07d',
                name: 'left',
                color: {
                    textColor: {
                        normal: '#212121'
                    }
                }
            }
        }
    }

    // title配置
    if (typeof headerTitle === 'string' && headerTitle !== '') {
        headerConfig.title = {
            style: 'text',
            text: headerTitle
        };
        if (typeof headerColor === 'string' && headerColor !== '') {
            headerConfig.title.color = {
                textColor: {
                    normal: headerColor
                }
            }
        }
    } else if (Object.prototype.toString.call(headerTitle) === '[object Object]') {
        headerConfig.title = headerTitle;
    }
    return headerConfig;
}

function jumpOtherWxApp ({url, appId, appName} = {appName: '小程序'}) {
    let baseUrl = '/flight/pages/middlePage/middlePage?url=';
    let jumpUrl = baseUrl + (/^http/.test(url) ? encodeURIComponent('/flight/pages/h5/h5?url=' + encodeURIComponent(url)) : encodeURIComponent(url));
    jumpUrl = `${jumpUrl}&app_name=${encodeURIComponent(appName)}&app_id=${appId}`;
    wx.miniProgram.navigateTo({
        url: jumpUrl
    });
}


export {
    jump,
    openSchema
}
